import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Püsikliendi hind kehtib registreeritud klientidele.
Täpne soodustus sõltub kliendikontol oleva summa suurusest.&lt;br&gt;&lt;br&gt;

Liitu kohe ja kingime Sulle 500 € kontoraha, mida saad kohe ostmisel kasutada!

  <span style="color:#85c1dc;">**FI:**</span>
  Kanta-asiakashinta koskee rekisteröityneitä asiakkaita.
Tarkka alennus riippuu asiakastililläsi olevasta summasta.&lt;br&gt;&lt;br&gt;

Liity heti – saat meiltä 500 € tilirahaa, jota voit käyttää heti ostoksissa!

  <span style="color:#85c1dc;">**RU:**</span>
  Цена для постоянных клиентов действует для зарегистрированных пользователей.
Точная скидка зависит от суммы на вашем клиентском счёте.&lt;br&gt;&lt;br&gt;

Присоединяйтесь сейчас — и мы подарим вам 500 € бонусных средств, которые можно использовать сразу при покупке!
*/
/* @__NO_SIDE_EFFECTS__ */
const m1320 = msg(
  mf`Püsikliendi hind kehtib registreeritud klientidele.
Täpne soodustus sõltub kliendikontol oleva summa suurusest.<br><br>

Liitu kohe ja kingime Sulle 500 € kontoraha, mida saad kohe ostmisel kasutada!`,
  mf`Kanta-asiakashinta koskee rekisteröityneitä asiakkaita.
Tarkka alennus riippuu asiakastililläsi olevasta summasta.<br><br>

Liity heti – saat meiltä 500 € tilirahaa, jota voit käyttää heti ostoksissa!`,
  mf`Цена для постоянных клиентов действует для зарегистрированных пользователей.
Точная скидка зависит от суммы на вашем клиентском счёте.<br><br>

Присоединяйтесь сейчас — и мы подарим вам 500 € бонусных средств, которые можно использовать сразу при покупке!`,
)

export { m1320 as 'w.module.product.prices_tooltiploggedout' }